import { TRIGGER_EVENT_LISTENER } from '../constants/MethodNames';
import { callingAPIMethodWithQueue } from '../utils/hsCallingUtils';
export default function triggerCallingEventListener(event) {
  return callingAPIMethodWithQueue(TRIGGER_EVENT_LISTENER, event);
}